var map = {
	"./black/kaishihuiyi2.png": "6Rjj",
	"./blue/kaishihuiyi2.png": "afdW",
	"./white/kaishihuiyi2.png": "0B5N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X5i/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/kaishihuiyi2\.png$
// module id = X5i/
// module chunks = 24